import Vue from 'vue'
import $ from 'jquery'
import eve from 'dom-events'

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  },
})

Vue.directive('on-jquery', {
  inserted (el, { modifiers, arg }) {
    const $el = $(el)
    const eventName = Object.keys(modifiers).join(' ')
    const emitEvent = arg || 'input'

    $el.on(eventName, (e) => {
      const isTriggeredWithJquery = !e.originalEvent
      if (isTriggeredWithJquery) {
        // Emit native input DOM event so that Vue can catch it
        eve.emit(el, emitEvent)
      }
    })
  },
})



// WEBPACK FOOTER //
// ./resources/assets/js/directives.js